export default "__VITE_ASSET__zPLEvGBw__"